import {
    CONTACT_AN_AGENT_ROUTE,
    COVERAGE_OPTIONS_ROUTE,
    DO_NOT_SELL_INFO,
    ENROLLMENT_ROUTE,
    MEDICARE_BASICS_ROUTE,
    MOBILE_TERMS,
    OUR_COMMITMENT_ROUTE,
    PARTS_OF_MEDICARE_ROUTE,
    PRIVACY_NOTICE_ROUTE,
    TERMS_ROUTE
} from 'utilities/routes';

export const companyLinks = [
    {
        link: OUR_COMMITMENT_ROUTE,
        text: 'Our Commitment'
    },
    {
        link: PRIVACY_NOTICE_ROUTE,
        text: 'Privacy Notice'
    },
    {
        link: TERMS_ROUTE,
        text: 'Terms of Service'
    },
    {
        link: MOBILE_TERMS,
        text: 'SMS/MMS Terms'
    },
    //{
    //    externalURL: true,
    //    lines1Text: 'Do Not Sell',
    //    lines2Text: 'My Information',
    //    link: DO_NOT_SELL_INFO,
    //    twoLines: true
    //},
    {
        link: CONTACT_AN_AGENT_ROUTE,
        text: 'Contact a Licensed Insurance Agent'
    }
];

export const companyLinks1 = [
    {
        link: OUR_COMMITMENT_ROUTE,
        text: 'Our Commitment'
    },
    {
        link: PRIVACY_NOTICE_ROUTE,
        text: 'Privacy Notice'
    },
    {
        link: TERMS_ROUTE,
        text: 'Terms of Service'
    },
    {
        link: MOBILE_TERMS,
        text: 'SMS/MMS Terms'
    },
    {
        externalURL: true,
        lines1Text: 'Do Not Sell',
        lines2Text: 'My Information',
        link: DO_NOT_SELL_INFO,
        twoLines: true
    }
];

export const disclaimerText =
    'PlanEnroll represents Medicare Advantage HMO, PPO, PFFS, and Prescription Drug Plan organizations that have a Medicare contract. Enrollment depends on the plan’s contract renewal. Not all plans offer all of these benefits. Benefits may vary by carrier and location. Limitations and exclusions may apply. Every year, Medicare evaluates plans based on a 5-star rating system. Part B Premium give-back is not available with all plans. Availability varies by carrier and location. Actual Part B premium reduction could be lower. Deductibles, copays and coinsurance may apply. PlanEnroll is a brand operated by Integrity Marketing Group, LLC and is used by its affiliated licensed insurance agencies that are certified to sell Medicare products. PlanEnroll is a non-government website and is not endorsed by the Centers for Medicare and Medicaid Services (CMS), the Department of Health and Human Services (DHHS) or any other government agency.';

/* eslint-disable no-template-curly-in-string */
export const disclaimerText2 =
    'We do not offer every plan available in your area. Currently we represent ${carrierCount} organizations which offer ${planCount} products in your area. Please contact <a style="color: #ffffff" href="https://www.medicare.gov/">Medicare.gov</a>, 1-800-MEDICARE, or your local State Health Insurance Program (SHIP) to get information on all of your options.';

export const disclaimerText3 =
    'To send a complaint to Medicare, call 1-800-MEDICARE (TTY users should call 1- 877-486-2048), 24 hours a day/7 days a week). If your complaint involves a broker or agent, be sure to include the name of the person when filing your grievance.';

export const learningCenterLinks = [
    {
        link: MEDICARE_BASICS_ROUTE,
        text: 'Medicare Basics'
    },
    {
        link: PARTS_OF_MEDICARE_ROUTE,
        text: 'Parts of Medicare'
    },
    {
        link: COVERAGE_OPTIONS_ROUTE,
        text: 'Coverage Options'
    },
    {
        link: ENROLLMENT_ROUTE,
        text: 'Enrollment'
    }
];
